import Colors from '@polestar/component-warehouse-react/tokens/colors/Colors';
const ProgressCircleTheme = {
    progressCircle: {
        light: {
            defaultProgressBarColor: Colors.accessibleSafetyOrange,
            monochromeProgressBarColor: Colors.stormGrey,
            defaultCircleBg: Colors.lightGrey,
            defaultPrimaryTextColor: Colors.black,
            outerCircleColor: Colors.black,
        },
        dark: {
            defaultProgressBarColor: Colors.accessibleSafetyOrange,
            monochromeProgressBarColor: Colors.lightGrey,
            defaultCircleBg: Colors.stormGrey,
            defaultPrimaryTextColor: Colors.white,
            outerCircleColor: Colors.white,
        },
    },
};
export default ProgressCircleTheme;
